<template>
    <div class="toplist" :class="'toplist__group--' + activeGroup" v-if="toplist">
        <h2>Toppliste {{ season }} - {{ user.location_name }}:</h2>
        <div class="unit-switch">
            <span class="unit-switch__label" :class="{ 'unit-switch__label--active': selectedUnit === 'kg' }">Kg</span>
            <button
                type="button"
                class="unit-switch__track"
                :class="{ 'unit-switch__track--liters': selectedUnit === 'liters' }"
                role="switch"
                :aria-checked="selectedUnit === 'liters'"
                aria-label="Bytt mellom kg og liter"
                @click="selectedUnit = selectedUnit === 'kg' ? 'liters' : 'kg'"
            >
                <span class="unit-switch__thumb"></span>
            </button>
            <span class="unit-switch__label" :class="{ 'unit-switch__label--active': selectedUnit === 'liters' }">Liter</span>
        </div>
        <ul class="toplist__list">
            <li class="toplist__list-item" v-for="person of rankedToplist" v-bind:key="person.id">
                <div class="toplist__list-amount">{{ person[selectedUnit].toFixed(1) }} {{ selectedUnit === 'liters' ? 'L' : 'kg' }}</div>
                <div class="toplist__list-name">{{ person.name }}</div>
            </li>
        </ul>
        <div class="toplist__name">{{ user.name }}</div>
        <div class="toplist__amount">{{ getUserAmount }} {{ unit === 'liter' ? 'L' : unit }}</div>
        <div class="toplist__notice" v-if="user.anonymous == 1">OBS: Din bruker er ikke med i toplisten siden du har valgt å være anonym.</div>
    </div>
</template>
<script>
    export default {
        props: ['toplist', 'user', 'getUserAmount', 'unit', 'groupName','activeGroup', 'season'],
        data() {
            return {
                selectedUnit: 'kg',
            };
        },
        computed: {
            rankedToplist() {
                return [...(this.toplist || [])].sort((a, b) => b[this.selectedUnit] - a[this.selectedUnit]);
            },
        },
    }
</script>